// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------------------------------------------------------
# Search Box Container Section
--------------------------------------------------------------*/
.K8bDqdxejU9aXG3FzbWX {
  padding: 32px 0 16px !important;
  width: 70%;
  margin: auto;
}
.K8bDqdxejU9aXG3FzbWX .HFMViXpPicsuyx82PPFA {
  font-size: 1.1rem;
  margin-bottom: 1.5rem;
  color: var(--default-color);
}
.K8bDqdxejU9aXG3FzbWX .HFMViXpPicsuyx82PPFA .R2PJNh_gFvyMJbcT6xPd {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--accent-color);
}
.K8bDqdxejU9aXG3FzbWX .HFMViXpPicsuyx82PPFA .tHAgD_NGQcfxNnlqNq5G {
  font-weight: 400;
  color: #687E97;
}
.K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .form-control {
  height: 48px;
  color: #0C3058;
  background-color: #ffffff;
  border: 1px solid #707070;
  border-radius: 30px !important;
  padding-right: 40px;
  box-shadow: 0px 1.55px 4.07px 0px rgba(0, 0, 0, 0.0236), 0px 7.32px 15.93px 0px rgba(0, 0, 0, 0.0364), 0px 19px 50px 0px rgba(0, 0, 0, 0.06);
  font-family: Rubik;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  padding-left: 110px;
}
.K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .form-control::placeholder {
  color: #687E97;
  font-size: 16px;
  font-weight: 400;
}
.K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .form-control:focus {
  border-color: #0068F5;
}
.K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .form-control:focus::placeholder {
  color: transparent;
}
.K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .btn, .K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .btn-primary {
  height: 32px;
  width: 32px;
  position: absolute;
  left: 8px;
  top: 8px;
  border-radius: 100% !important;
  transition: all 0.3s;
  background-color: #0068F5 !important;
  color: #FFFFFF;
  z-index: 99;
  padding: 0;
  border: 0;
}
.K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .btn:disabled, .K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .btn-primary:disabled {
  opacity: 100%;
}
.K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .btn:focus, .K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .btn-primary:focus {
  outline: none;
}
html[dir=ltr] .K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .btn, html[dir=ltr] .K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .btn-primary {
  left: auto;
  right: 8px;
}
.K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .btn-primary svg {
  bottom: 1px;
  position: relative;
  fill: #ffffff;
}
.K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .btn-clear {
  position: absolute;
  top: 8px;
  left: 98px;
  background: none !important;
  border: 1px solid #EBEEF2;
  border-radius: 8px !important;
  color: var(--default-color);
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-left: -2rem;
  cursor: pointer;
  transition: color 0.3s;
  z-index: 99;
}
.K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .btn-clear:hover {
  color: var(--accent-color) !important;
  background-color: transparent;
}
.K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .btn-clear svg {
  fill: #0C3058;
  font-size: 1.7rem;
}
.K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .btn-clear:focus {
  box-shadow: none;
}
html[dir=ltr] .K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .btn-clear {
  left: auto;
  right: 66px;
}
.K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .btn-seperator {
  position: absolute;
  top: 8px;
  left: 52px;
  width: 1px;
  height: 32px;
  background-color: #D7DDE4;
  z-index: 98;
}
html[dir=ltr] .K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .btn-seperator {
  left: auto;
  right: 52px;
}
@media (max-width: 575.98px) {
  .K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc form {
    row-gap: 1rem;
  }
  .K8bDqdxejU9aXG3FzbWX .u14HhW9dvVOs8O6iPUZc .olU3MprG4QvZmqeqsihw {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 575.98px) {
  .K8bDqdxejU9aXG3FzbWX {
    padding: 0 !important;
    width: 100%;
    margin: auto;
  }
  .K8bDqdxejU9aXG3FzbWX .container {
    padding: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./GeneralComponents/SearchBox/SearchBox.module.scss"],"names":[],"mappings":"AAAA;;+DAAA;AAGA;EACI,+BAAA;EACA,UAAA;EACA,YAAA;AACJ;AACI;EACI,iBAAA;EACA,qBAAA;EACA,2BAAA;AACR;AACQ;EACI,kBAAA;EACA,gBAAA;EACA,0BAAA;AACZ;AAEQ;EACI,gBAAA;EACA,cAAA;AAAZ;AAKQ;EACI,YAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,8BAAA;EACA,mBAAA;EACA,4IAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAHZ;AAKY;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AAHhB;AAMY;EACI,qBAAA;AAJhB;AAMgB;EACI,kBAAA;AAJpB;AASQ;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,8BAAA;EACA,oBAAA;EACA,oCAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;AAPZ;AASY;EACI,aAAA;AAPhB;AAUY;EACI,aAAA;AARhB;AAWY;EACI,UAAA;EACA,UAAA;AAThB;AAeY;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AAbhB;AAiBQ;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,2BAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;AAfZ;AAiBY;EACI,qCAAA;EACA,6BAAA;AAfhB;AAkBY;EACI,aAAA;EACA,iBAAA;AAhBhB;AAmBY;EACI,gBAAA;AAjBhB;AAoBY;EACI,UAAA;EACA,WAAA;AAlBhB;AAsBQ;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;AApBZ;AAsBY;EACI,UAAA;EACA,WAAA;AApBhB;AAyBI;EAEQ;IACI,aAAA;EAxBd;EA2BU;IACI,WAAA;IACA,uBAAA;EAzBd;AACF;;AA6BA;EACI;IACI,qBAAA;IACA,WAAA;IACA,YAAA;EA1BN;EA2BM;IACI,qBAAA;EAzBV;AACF","sourcesContent":["/*--------------------------------------------------------------\r\n# Search Box Container Section\r\n--------------------------------------------------------------*/\r\n.search-box-container {\r\n    padding: 32px 0 16px !important;\r\n    width: 70%;\r\n    margin: auto;\r\n\r\n    .results-summary {\r\n        font-size: 1.1rem;\r\n        margin-bottom: 1.5rem;\r\n        color: var(--default-color);\r\n\r\n        .results-count {\r\n            font-size: 1.25rem;\r\n            font-weight: 600;\r\n            color: var(--accent-color);\r\n        }\r\n\r\n        .search-term {\r\n            font-weight: 400;\r\n            color: #687E97;\r\n        }\r\n    }\r\n\r\n    .search-form-wrapper {\r\n        :global(.form-control) {\r\n            height: 48px;\r\n            color: #0C3058;\r\n            background-color: #ffffff;\r\n            border: 1px solid #707070;\r\n            border-radius: 30px !important;\r\n            padding-right: 40px;\r\n            box-shadow: 0px 1.55px 4.07px 0px rgba(0, 0, 0, 0.0236), 0px 7.32px 15.93px 0px rgba(0, 0, 0, 0.0364), 0px 19px 50px 0px rgba(0, 0, 0, 0.06);\r\n            font-family: Rubik;\r\n            font-weight: 400;\r\n            font-style: Regular;\r\n            font-size: 16px;\r\n            line-height: 24px;\r\n            letter-spacing: 0%;\r\n            padding-left: 110px;\r\n\r\n            &::placeholder {\r\n                color: #687E97;\r\n                font-size: 16px;\r\n                font-weight: 400;\r\n            }\r\n\r\n            &:focus {\r\n                border-color: #0068F5;\r\n\r\n                &::placeholder {\r\n                    color: transparent;\r\n                }\r\n            }\r\n        }\r\n\r\n        :global(.btn), :global(.btn-primary) {\r\n            height: 32px;\r\n            width: 32px;\r\n            position: absolute;\r\n            left: 8px;\r\n            top: 8px;\r\n            border-radius: 100% !important;\r\n            transition: all 0.3s;\r\n            background-color: #0068F5 !important;\r\n            color: #FFFFFF;\r\n            z-index: 99;\r\n            padding: 0;\r\n            border: 0;\r\n\r\n            &:disabled {\r\n                opacity: 100%;\r\n            }\r\n\r\n            &:focus {\r\n                outline: none;\r\n            }\r\n\r\n            :global(html[dir=ltr]) & {\r\n                left: auto;\r\n                right: 8px;\r\n            }\r\n        }\r\n\r\n        :global(.btn-primary) {\r\n\r\n            svg {\r\n                bottom: 1px;\r\n                position: relative;\r\n                fill: #ffffff;\r\n            }\r\n        }\r\n\r\n        :global(.btn-clear) {\r\n            position: absolute;\r\n            top: 8px;\r\n            left: 98px;\r\n            background: none !important;\r\n            border: 1px solid #EBEEF2;\r\n            border-radius: 8px !important;\r\n            color: var(--default-color);\r\n            font-size: 1.2rem;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            padding: 0;\r\n            margin-left: -2rem;\r\n            cursor: pointer;\r\n            transition: color 0.3s;\r\n            z-index: 99;\r\n\r\n            &:hover {\r\n                color: var(--accent-color) !important;\r\n                background-color: transparent;\r\n            }\r\n\r\n            svg {\r\n                fill: #0C3058;\r\n                font-size: 1.7rem;\r\n            }\r\n\r\n            &:focus {\r\n                box-shadow: none;\r\n            }\r\n\r\n            :global(html[dir=ltr]) & {\r\n                left: auto;\r\n                right: 66px;\r\n            }\r\n        }\r\n\r\n        :global(.btn-seperator) {\r\n            position: absolute;\r\n            top: 8px;\r\n            left: 52px;\r\n            width: 1px;\r\n            height: 32px;\r\n            background-color: #D7DDE4;\r\n            z-index: 98;\r\n\r\n            :global(html[dir=ltr]) & {\r\n                left: auto;\r\n                right: 52px;\r\n            }\r\n        }\r\n    }\r\n\r\n    @media (max-width: 575.98px) {\r\n        .search-form-wrapper {\r\n            form {\r\n                row-gap: 1rem;\r\n            }\r\n\r\n            .btn {\r\n                width: 100%;\r\n                justify-content: center;\r\n            }\r\n        }\r\n    }\r\n}\r\n@media (max-width: 575.98px) {\r\n    .search-box-container {\r\n        padding: 0 !important;\r\n        width: 100%;\r\n        margin: auto;\r\n        :global(.container) {\r\n            padding: 0 !important;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search-box-container": `K8bDqdxejU9aXG3FzbWX`,
	"results-summary": `HFMViXpPicsuyx82PPFA`,
	"results-count": `R2PJNh_gFvyMJbcT6xPd`,
	"search-term": `tHAgD_NGQcfxNnlqNq5G`,
	"search-form-wrapper": `u14HhW9dvVOs8O6iPUZc`,
	"btn": `olU3MprG4QvZmqeqsihw`
};
export default ___CSS_LOADER_EXPORT___;
